/**
 * Souhlas s cookies a Google Consent Mode v2.
 *
 * Výchozí stav je vše zamítnuto (analytics_storage, ad_storage, ad_user_data,
 * ad_personalization = denied). Bez souhlasu tak Google nezapisuje cookies,
 * ale v režimu Consent Mode posílá anonymní pingy – GA4 z nich modeluje
 * návštěvnost a konverze, takže měření úplně nepadne.
 *
 * Samotnou volbu ukládáme do localStorage. To je nezbytné úložiště (bez něj
 * by se lišta ukazovala při každé návštěvě) a souhlas nepotřebuje.
 */

const KEY = 'seknuto_consent_v1';
const VERSION = 1;

export const DENIED = {
  analytics_storage: 'denied',
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
};

export function readConsent() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY));
    if (v && v.version === VERSION) return v;
  } catch { /* poškozená nebo blokovaná hodnota = jako by volba nebyla */ }
  return null;
}

export function toGtagConsent({ analytics, marketing }) {
  const a = analytics ? 'granted' : 'denied';
  const m = marketing ? 'granted' : 'denied';
  return { analytics_storage: a, ad_storage: m, ad_user_data: m, ad_personalization: m };
}

export function applyConsent(choice) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('consent', 'update', toGtagConsent(choice));
  }
}

export function saveConsent({ analytics, marketing }) {
  const choice = {
    version: VERSION,
    analytics: !!analytics,
    marketing: !!marketing,
    updatedAt: new Date().toISOString(),
  };
  try { localStorage.setItem(KEY, JSON.stringify(choice)); } catch { /* privátní režim */ }
  applyConsent(choice);
  window.dispatchEvent(new CustomEvent('seknuto:consent', { detail: choice }));
  return choice;
}

// Stav souhlasu pro backend (atribuce poptávky): granted / denied / partial / unknown
export function consentState() {
  const v = readConsent();
  if (!v) return 'unknown';
  if (v.analytics && v.marketing) return 'granted';
  if (!v.analytics && !v.marketing) return 'denied';
  return 'partial';
}

export const hasMarketingConsent = () => !!readConsent()?.marketing;

// Patička („Nastavení cookies") otevře lištu znovu
export const openConsentSettings = () => window.dispatchEvent(new Event('seknuto:open-consent'));
